/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} General_No_SelectionInputs */

const en_general_no_selection = /** @type {(inputs: General_No_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No selection`)
};

const de_general_no_selection = /** @type {(inputs: General_No_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Auswahl`)
};

/**
* | output |
* | --- |
* | "No selection" |
*
* @param {General_No_SelectionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const general_no_selection = /** @type {((inputs?: General_No_SelectionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<General_No_SelectionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_general_no_selection(inputs)
	return de_general_no_selection(inputs)
});